<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="isShown"
      :modal-append-to-body="false" 
      :close-on-click-modal="false"
      v-loading="isLoading">
      <el-form :model="form" ref="form">
        <el-form-item
          label="営業時間名"
          :label-width="formLabelWidth"
          prop="timeName"
          :error="errors.timeName">
          <el-input
            v-model="form.timeName"
            auto-complete="off"
            placeholder="営業時間名">
          </el-input>
        </el-form-item>
        <el-form-item
          label="開始"
          :error="errors.startHour"
          :label-width="formLabelWidth">
          <el-select v-model="form.startHour">
            <el-option
             v-for="(item, index) in Array(49)"
             :key="index"
             :label="index"
             :value="index"
             auto-complete="off">
            </el-option>
          </el-select>
          時
        </el-form-item>
        <el-form-item
          label="終了"
          :error="errors.endHour"
          :label-width="formLabelWidth">
          <el-select v-model="form.endHour">
            <el-option
             v-for="(item, index) in Array(49)"
             :key="index"
             :label="index"
             :value="index"
             auto-complete="off">
            </el-option>
          </el-select>
          時
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShown = false">キャンセル</el-button>
        <el-button size="mini" type="success" @click="submit">{{ createMode ? '登録' : '更新' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TimeSettingDialog',
  data () {
    const formDefaultValue = {
      pk: null,
      slug: null,
      timeName: '',
      startHour: 0,
      startMin: 0,
      endHour: 0,
      endMin: 0,
      listOrder: 0,
    }
    return {
      isShown: false,
      isLoading: false,
      form: {...formDefaultValue},
      formDefaultValue: formDefaultValue,
      errors: {
        timeName: '',
        startHour: '',
        endHour: '',
      },
      formLabelWidth: '120px',
    }
  },
  computed: {
    createMode () {
      // true: 新規作成 / false: 編集
      return !this.form.slug
    },
    title () {
      return this.createMode ? '新規追加' : '編集'
    },
  },
  methods: {
    show (createMode, data) {
      this.reset()
      if (createMode) {
        this.form.listOrder = data.listOrder
      } else {
        this.form = {...data}
      }
      this.isShown = true
    },
    hide () {
      this.isShown = false
      this.reset()
    },
    reset () {
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = ''
      })
      this.form = {...this.formDefaultValue}
    },
    submit () {
      this.isLoading = true
      let data = {...this.form}
      let api
      if (this.createMode) {
        delete data['slug']
        api = this.$request.timeSettings.addTimezone(data)
      } else {
        api = this.$request.timeSettings.editTimezone(data)
      }

      api.then(res => {
        this.$message({
          message: this.createMode ? '登録しました。' : '更新しました。',
        })
        if (this.createMode) {
          this.$emit('submitted', ['add', res.body])
        } else {
          this.$emit('submitted', ['edit', res.body])
        }
        this.hide()
        return null
      }, err => {
        const body = err.response.body
        this.$parent.$parent.$emit('requestError', [body, this.errors])
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
}
</script>

<style lang="sass" scoped>
.el-input,
.el-select,
.el-input-number
  width: 300px
</style>



// WEBPACK FOOTER //
// src/components/TimeSetting/Dialog.vue